export enum EstadoAlumnoCarrera {
    REGISTRADO = 0, // REGISTRADO
    INICIALIZACION_KV_PENDIENTE = 1, // INICIALIZACION KV PENDIENTE
    PENDIENTE = 1, // PENDIENTE
    INICIALIZADO = 2, // INICIALIZADO
    ACCESO_BLOQUEADO = 3, // ACCESO BLOQUEADO
    OFERTA_INVALIDA = 4, // OFERTA INVALIDA
    OFERTA_VENCIDA = 5, // OFERTA VENCIDA
    GENERANDO_OFERTA_VENCIDA = 6, // GENERANDO OFERTA VENCIDA
    GENERANDO_OFERTA_INVALIDA = 7, // GENERANDO OFERTA INVALIDA
}

export const normalizeEstado = (estado: string): string => {
    return estado
        .replace(/\s+/g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
};